module.exports = __webpack_public_path__ + "img/Retailer_explore_three.10e5fbe4.png";